const language = {
    'pt':
    {
        add_new: 'Adicionar Novo Grupo',
        cancel: 'Cancelar', back: 'Voltar',
        category: 'Grupo',
        category_new: 'Novo Grupo',
        category_edit: 'Editar Grupo',
        category_list: 'Lista de Grupos',
        close: 'Fechar',
        color: 'Cor',
        color_primary: 'Cor Primária',
        color_secondary: 'Cor Secundária',
        color_placeholder: 'Introduza a cor',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registo',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        description: 'Descrição',
        edit: 'Editar',
        edit_title: 'Editar Registo',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        filter_placeholder: 'Procurar',
        intranet: 'Contactos da Intranet',
        admin: 'Administrador',
        id: 'ID',
        name: 'Nome',
        contact: 'Contacto',
        email: 'Email',
        departament: 'Departamento',
        name_placeholder: 'Introduza o nome',
        group: 'Grupo',
        group_name: 'Nome do Grupo',
        mais: 'Mais',
        mem: 'Membros',
        membros: 'Membros do',
        mensagem: 'Mensagem',
        mensagem_placeholder: 'Escrever mensagem',
        enviar: 'Enviar',
        insert_title: 'Novo Registo',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        principal: 'Principal',
        remove: 'Remover',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_title: 'Título',
        table_parent: 'Parent',
        table_date: 'Data',
        table_state: 'Estado',
        table_actions: 'Acções',
        table_empty: 'Nada a Apresentar',
        save: 'Salvar',
        softwares: 'Softwares',
        software_placeholder: 'Adicionar um novo software',
        local: 'Localidade',
        sede: 'Sede do departamento',
        photo: 'Carregar Foto',
        noPhoto: 'Sem foto',
        add_membros:'Adicionar Membros ao Grupo',
        selected_members:'Membros selecionados',
        actions:'Ações',
        select: 'Selecionar',
    },
    'en':
    {
        mais: 'More',
        mem: 'Members',
        enviar: 'Send',
        actions :'Actions',
        selected_members:'Selected members',
        add_membros :'Add Members to Group',
        add_new: 'Add new',
        calendar: 'Calendar',
        cancel: 'Cancel',
        category: 'Department',
        category_new: 'New Department',
        category_edit: 'Editar Department',
        category_list: 'List of Departments',
        close: 'Close',
        color: 'Color',
        color_primary: 'Primary Color',
        color_secondary: 'Secondary Color',
        color_placeholder: 'Insert the color',
        group: 'Group',
        group_name: 'Department name',
        membros: 'Members of',
        mensagem: 'Message',
        mensagem_placeholder: 'Write a message',
        delete: 'Delete',
        delete_title: 'Delete Regist',
        delete_text: 'Are you sure you want to continue?',
        delete_confirm: 'Yes',
        delete_cancel: 'No',
        delete_error: 'Problem deleting the element!',
        delete_success: 'Element deleted successfully!',
        description: 'Description',
        edit: 'Edit',
        edit_title: 'Edit Regist',
        edit_text: 'Are you sure you want to continue?',
        edit_confirm: 'Yes',
        edit_cancel: 'No',
        edit_error: 'Problem updating element!',
        edit_success: 'Successful updated element!',
        intranet: 'Intranet Contacts',
        admin: 'Administrator',
        id: 'ID',
        name: 'Name',
        contact: 'Contact',
        email: 'Email',
        departament: 'Department',
        name_placeholder: 'Insert the name',
        insert_title: 'New Regist',
        insert_text: 'Are you sure you want to continue?',
        insert_confirm: 'Yes',
        insert_cancel: 'No',
        insert_error: 'Problem updating element!',
        insert_success: 'Successful updated element!',
        principal: 'Principal',
        remove: 'Remove',
        table_rows_per_page: 'Regist by page:',
        table_separator: 'of',
        table_all: 'All',
        table_title: 'Title',
        table_parent: 'Parent',
        table_date: 'Date',
        table_state: 'State',
        table_actions: 'Actions',
        table_empty: 'Nothing to Show',
        save: 'Save',
        softwares: 'Softwares',
        software_placeholder: 'Add a new Software',
        local: 'Region',
        sede: 'Department Location',
        photo: 'Upload Photo',
        noPhoto: 'No photo',
        select: 'Select',
    },
    'es':{
        add_new: 'Agregar Nuevo Grupo',
cancel: 'Cancelar', back: 'Voltar',
category: 'Grupo',
category_new: 'Nuevo Grupo',
category_edit: 'Editar Grupo',
category_list: 'Lista de Grupos',
close: 'Cerrar',
color: 'Color',
color_primary: 'Color Primario',
color_secondary: 'Color Secundario',
color_placeholder: 'Introduce el color',
delete: 'Eliminar',
delete_title: 'Eliminar Registro',
delete_text: '¿Está seguro que desea continuar?',
delete_confirm: 'Sí',
delete_cancel: 'No',
delete_error: '¡Problema al eliminar el registro!',
delete_success: '¡Registro eliminado con éxito!',
description: 'Descripción',
edit: 'Editar',
edit_title: 'Editar Registro',
edit_text: '¿Está seguro que desea continuar?',
edit_confirm: 'Sí',
edit_cancel: 'No',
edit_error: '¡Problema al actualizar el registro!',
edit_success: '¡Registro actualizado con éxito!',
filter_placeholder: 'Buscar',
intranet: 'Contactos de la Intranet',
admin: 'Administrador',
id: 'ID',
name: 'Nombre',
contact: 'Contacto',
email: 'Correo electrónico',
departament: 'Departamento',
name_placeholder: 'Introduce el nombre',
group: 'Grupo',
group_name: 'Nombre del Grupo',
mais: 'Más',
mem: 'Miembros',
membros: 'Miembros de',
mensagem: 'Mensaje',
mensagem_placeholder: 'Escribe un mensaje',
enviar: 'Enviar',
insert_title: 'Nuevo Registro',
insert_text: '¿Está seguro que desea continuar?',
insert_confirm: 'Sí',
insert_cancel: 'No',
insert_error: '¡Problema al insertar el registro!',
insert_success: '¡Registro insertado con éxito!',
principal: 'Principal',
remove: 'Eliminar',
table_rows_per_page: 'Registros por página:',
table_separator: 'de',
table_all: 'Todos',
table_title: 'Título',
table_parent: 'Padre',
table_date: 'Fecha',
table_state: 'Estado',
table_actions: 'Acciones',
table_empty: 'Nada que mostrar',
save: 'Guardar',
softwares: 'Softwares',
software_placeholder: 'Agregar un nuevo software',
local: 'Localidad',
sede: 'Sede del departamento',
photo: 'Cargar Foto',
noPhoto: 'Sin foto',
add_membros: 'Agregar Miembros al Grupo',
selected_members: 'Miembros seleccionados',
actions: 'Acciones',
select: 'Seleccionar',

    },
    'fr':{
add_new: 'Ajouter Nouveau Groupe',
cancel: 'Annuler',
category: 'Groupe',
category_new: 'Nouveau Groupe',
category_edit: 'Modifier Groupe',
category_list: 'Liste des Groupes',
close: 'Fermer',
color: 'Couleur',
color_primary: 'Couleur Principale',
color_secondary: 'Couleur Secondaire',
color_placeholder: 'Entrez la couleur',
delete: 'Supprimer',
delete_title: 'Supprimer Enregistrement',
delete_text: 'Êtes-vous sûr de vouloir continuer ?',
delete_confirm: 'Oui',
delete_cancel: 'Non',
delete_error: 'Problème lors de la suppression de l’enregistrement !',
delete_success: 'Enregistrement supprimé avec succès !',
description: 'Description',
edit: 'Modifier',
edit_title: 'Modifier Enregistrement',
edit_text: 'Êtes-vous sûr de vouloir continuer ?',
edit_confirm: 'Oui',
edit_cancel: 'Non',
edit_error: 'Problème lors de la mise à jour de l’enregistrement !',
edit_success: 'Enregistrement mis à jour avec succès !',
filter_placeholder: 'Rechercher',
intranet: 'Contacts de l’Intranet',
admin: 'Administrateur',
id: 'ID',
name: 'Nom',
contact: 'Contact',
email: 'Email',
departament: 'Département',
name_placeholder: 'Entrez le nom',
group: 'Groupe',
group_name: 'Nom du Groupe',
mais: 'Plus',
mem: 'Membres',
membros: 'Membres de',
mensagem: 'Message',
mensagem_placeholder: 'Écrire un message',
enviar: 'Envoyer',
insert_title: 'Nouvel Enregistrement',
insert_text: 'Êtes-vous sûr de vouloir continuer ?',
insert_confirm: 'Oui',
insert_cancel: 'Non',
insert_error: 'Problème lors de l’insertion de l’enregistrement !',
insert_success: 'Enregistrement inséré avec succès !',
principal: 'Principal',
remove: 'Retirer',
table_rows_per_page: 'Enregistrements par page :',
table_separator: 'de',
table_all: 'Tous',
table_title: 'Titre',
table_parent: 'Parent',
table_date: 'Date',
table_state: 'État',
table_actions: 'Actions',
table_empty: 'Rien à afficher',
save: 'Enregistrer',
softwares: 'Logiciels',
software_placeholder: 'Ajouter un nouveau logiciel',
local: 'Localité',
sede: 'Siège du département',
photo: 'Télécharger une Photo',
noPhoto: 'Pas de photo',
add_membros: 'Ajouter des Membres au Groupe',
selected_members: 'Membres sélectionnés',
actions: 'Actions',
select: 'Sélectionner',

    }
}

module.exports = {
    language
};